// @flow

import { Text } from 'reshaped';

import { useTranslator } from '@gandi/translate';

export function Header(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <>
      <Text variant="featured-3" weight="bold">
        {__('Tell us more, to prepare product invoicing')}
      </Text>
      <Text variant="body-3" color="neutral-faded">
        {__('Unless otherwise stated, all fields are mandatory')}
      </Text>
    </>
  );
}
